<div class="container narrow-container extra-small">
  <mat-card class="office-card">
    <mat-card-content class="card-content">
      <nav mat-tab-nav-bar class="navigation-tabs" [tabPanel]="tabPanel">
        <a
          mat-tab-link
          [routerLink]="['./general']"
          routerLinkActive
          #general="routerLinkActive"
          [active]="general.isActive"
          class="compact-tab"
        >
          {{ 'labels.inputs.General' | translate }}
        </a>
        @for (officeDatatable of officeDatatables; track officeDatatable) {
          <span>
            <a
              mat-tab-link
              *LOSxHasPermission="'READ_' + officeDatatable.registeredTableName"
              [routerLink]="['./datatables', officeDatatable.registeredTableName]"
              routerLinkActive
              #datatable="routerLinkActive"
              [active]="datatable.isActive"
              class="compact-tab"
            >
              {{ officeDatatable.registeredTableName }}
            </a>
          </span>
        }
      </nav>

      <mat-tab-nav-panel #tabPanel class="tab-panel">
        <router-outlet></router-outlet>
      </mat-tab-nav-panel>
    </mat-card-content>
  </mat-card>
</div>
